<template>
  <transition name="fade">
    <div class="limited-time-award-popup" v-if="visible">
      <div class="rule-popup">
        <p class="dialog-title">{{ letter.seeAward }}</p>
        <p class="award-content">{{ awardDetail }}</p>
        <Button
          class="close-btn"
          pointClass="j-close-tip-btn"
          @click="hidePopup"
        ></Button>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'limitedTimeAwardDeatailPopup',
  props: ['visible', 'awardDetail'],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      letter: state => state.letter
    }),
    ...mapGetters(['gameInfoConfig'])
  },
  methods: {
    hidePopup() {
      this.$emit('onClose');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.limited-time-award-popup {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 101;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);

  .rule-popup {
    position: relative;
    background-size: 100% 100%;
    @psetbg ('common-popup.png');

    .award-content {
      padding: 0 42px;
      line-height: 30px;
      font-size: 23px;
      color: var(--global-tip-popup-text);
      text-align: center;
    }
    .close-btn {
      position: absolute;
      @psetbg ('close.png');
    }
  }
}
</style>
